import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { history } from '../router';
import LoadingDots from './ui/LoadingDots';
import ReactPaginate from 'react-paginate';
import { PAGINATION, REQUEST_TYPE, URL_PREFIX } from '../const/forms';
// import {ActionsDefaultState, ActionsRules} from '../const/action_rules';
import {
  copyForm,
  deleteForm,
  getForms,
  revokeForm,
  getHistory,
  createForm,
} from '../actions';
import { getProcessStatus } from './Utils';
import '../static/css/main.scss';

import HistoryStatusModal from './program/history/';
import { ConfirmModal } from '../modules/metajson-sub/src/widgets/modals/confirm-modal';

// import LastComment from '../modules/metajson-sub/src/components/LastComment';

const LANGUAGE = {
  ru: 'Русский',
  en: 'Русский и Английский',
};

class RequestList extends Component {
  constructor() {
    super();
    this.onDelete = this.onDelete.bind(this);
    this.onCopy = this.onCopy.bind(this);
    // this.onRevoke = this.onRevoke.bind(this);
    this.showHistory = this.showHistory.bind(this);
    this.paginationClick = this.paginationClick.bind(this);
    this.onCreate = this.onCreate.bind(this);
    this.modal = HistoryStatusModal;
    this.revokeModal = ConfirmModal;
    this.state = {
      currentPage: PAGINATION.page,
    };
    // this.lastComment = LastComment;
  }

  goForm(event, opts) {
    event.stopPropagation();
    event.preventDefault();
    const { form_type, process_id } = opts;
    history.push(`${URL_PREFIX}/forms/${form_type}/${process_id}`);
  }

  onDelete(event, form_type, process_id) {
    event.stopPropagation();
    event.preventDefault();
    this.props.deleteForm(form_type, process_id, this.state.currentPage);
  }

  onCopy(event, form_type, process_id) {
    event.stopPropagation();
    event.preventDefault();
    this.props.copyForm(form_type, process_id);
  }

  showHistory(e, request) {
    e.stopPropagation();
    e.preventDefault();

    this.modal.show(request);
  }

  onModalRevoke(e, form_type, process_id) {
    e.stopPropagation();
    e.preventDefault();

    this.revokeModal.show(form_type, process_id);
  }

  getRowAct(item) {
    return item.stage_title;
  }

  paginationClick(e) {
    this.props.getForms(e.selected + 1, PAGINATION.pagesize);
    this.setState({ currentPage: e.selected + 1 });
  }

  // Дает возможность создать заявку на статус из заявки на экспетизу,
  // поэтому target_request_type здесь всегда равен 1
  onCreate(e, data) {
    e.stopPropagation();
    e.preventDefault();
    const { createForm } = this.props;
    const { target_request_type, request_id } = data;

    createForm({
      typeRequest: target_request_type,
      source: 'expertise',
      request_id: request_id,
    });
  }

  // onShowLastComment(event, form_type, process_id) {
  //   event.stopPropagation();
  //   event.preventDefault();
  //   this.props.getHistory(process_id);
  //   this.lastComment.show();
  // }

  render() {
    const { forms, mode, loaders, pagination } = this.props;

    return (
      <LoadingDots
        show={typeof loaders['forms'] !== 'undefined' || !this.props.modeLoaded}
      >
        {forms.length > 0 && (
          <div className="table-responsive text-block">
            <table className="table table-bordered table-hover request-list">
              <thead>
                <tr>
                  <td>ID</td>
                  <td>Проект</td>
                  <td style={{ width: '115px' }}>Тип заявки</td>
                  {/* <td>Язык</td> */}
                  <td style={{ width: '140px' }}>Дата создания черновика</td>
                  <td style={{ width: '140px' }}>Дата регистрации</td>
                  <td>Статус</td>
                  <td>Операции</td>
                </tr>
              </thead>
              <tbody>
                {forms
                  .sort((a, b) => {
                    return new Date(a.created_at) < new Date(b.created_at)
                      ? 1
                      : -1;
                  })
                  .map((item) => {
                    const { visible_buttons: visibleButtonsAllData } = item;

                    const visibleButtonsListView =
                      visibleButtonsAllData?.list_form_item;

                    return (
                      <tr
                        className="report-list-group"
                        key={item.item_id}
                        onClick={(event) =>
                          this.goForm(event, {
                            form_type: item.form_type,
                            process_id: item.process_id,
                          })
                        }
                      >
                        {/* ID */}
                        <td>{item.process_id || ''}</td>

                        {/* Проект */}
                        <td>{item.project ?? ''}</td>

                        {/* Тип заявки */}
                        <td>
                          {REQUEST_TYPE[item.form_settings.typeRequest] || ''}
                        </td>

                        {/* Язык */}
                        {/* <td>
                          {LANGUAGE?.[item?.form_settings?.language] ?? ''}
                        </td> */}

                        {/* Дата создания черновика */}
                        <td>{new Date(item.created_at).toLocaleString()}</td>

                        {/* Дата регистрации */}
                        <td>
                          {item.registered_at
                            ? new Date(item.registered_at).toLocaleString()
                            : ''}
                        </td>

                        {/* Статус */}
                        <td className="request-list__status">
                          <div className="btn-group-vertical" role="group">
                            <button className={`btn btn-primary`}>
                              {getProcessStatus(item)}
                            </button>
                            <button
                              className="btn btn-success"
                              onClick={(event) =>
                                this.showHistory(event, item.process_id)
                              }
                              title="История изменений"
                            >
                              История изменений
                            </button>
                          </div>
                        </td>

                        {/* Операции */}
                        <td>
                          {visibleButtonsListView.clone ? (
                            <>
                              <button
                                title="Копировать"
                                className="btn btn-primary btn-xs"
                                onClick={(event) =>
                                  this.onCopy(
                                    event,
                                    item.form_type,
                                    item.process_id,
                                  )
                                }
                              >
                                <span className="glyphicon glyphicon-duplicate" />
                              </button>
                              &nbsp;
                            </>
                          ) : null}
                          {visibleButtonsListView.delete ? (
                            <>
                              <button
                                className="btn btn-danger btn-xs"
                                onClick={(event) =>
                                  this.onDelete(
                                    event,
                                    item.form_type,
                                    item.process_id,
                                  )
                                }
                                title="Удалить"
                              >
                                <span className="glyphicon glyphicon-remove" />
                              </button>
                              &nbsp;
                            </>
                          ) : null}
                          {visibleButtonsListView.reject ? (
                            <>
                              <button
                                className="btn btn-primary btn-xs"
                                onClick={(event) =>
                                  this.onModalRevoke(
                                    event,
                                    item.form_type,
                                    item.process_id,
                                  )
                                }
                                title="Отозвать"
                              >
                                <span className="glyphicon glyphicon-arrow-left" />
                              </button>
                              &nbsp;
                            </>
                          ) : null}
                          {item.form_settings?.typeRequest === 0 &&
                          item.form_status === 14 &&
                          visibleButtonsListView.create_status ? (
                            <button
                              className="btn btn-primary btn-xs"
                              onClick={(event) =>
                                this.onCreate(event, {
                                  target_request_type: 1,
                                  request_id: item.process_id,
                                })
                              }
                            >
                              <span>Создать заявку на статус</span>
                            </button>
                          ) : null}
                          {/* } */}
                          {/*{item.form_status != 0 && <button className="btn btn-primary btn-xs" onClick={event => this.onRevoke(event, item.form_type, item.process_id)} title="Отозвать">*/}
                          {/*  <span className="glyphicon glyphicon-arrow-left" />*/}
                          {/*</button>}*/}
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
            {pagination.total > pagination.pagesize ? (
              <ReactPaginate
                breakLabel="..."
                nextLabel=">"
                onPageChange={this.paginationClick}
                pageRangeDisplayed={5}
                pageCount={Math.ceil(pagination.total / pagination.pagesize)}
                previousLabel="<"
                renderOnZeroPageCount={null}
                className="paginator"
              />
            ) : null}
            <HistoryStatusModal ref={(modal) => (this.modal = modal)} />
            <ConfirmModal
              ref={(modal) => (this.revokeModal = modal)}
              func={this.props.revokeForm}
            />
          </div>
        )}
        {forms.length === 0 && (
          <div className="text-block text-block_empty">
            Не найдено ни одной заявки
          </div>
        )}
        {/* <LastComment
          ref={(modal) => this.lastComment = modal}
          data={{
            history: this.props.history,
            userRole: this.props.userRole,
            loaders,
            extRules: {
              ActionsDefaultState,
              ActionsRules,
            }
          }}
        /> */}
      </LoadingDots>
    );
  }
}

RequestList.propTypes = {
  forms: PropTypes.array.isRequired,
  pagination: PropTypes.shape({}).isRequired,
  loaders: PropTypes.shape({}).isRequired,
  history: PropTypes.array,
  userRole: PropTypes.string,
};

const mapDispatchToProps = {
  copyForm,
  deleteForm,
  getForms,
  getHistory,
  revokeForm,
  createForm,
};

const mapStateToProps = (state) => ({
  mode: state.forms.mode,
  forms: state.forms.forms,
  loaders: state.forms.loaders,
  modeLoaded: state.forms.modeLoaded,
  pagination: state.forms.pagination,
  history: state.forms.history,
  userRole: state.forms.user.userRole,
});

export default connect(mapStateToProps, mapDispatchToProps)(RequestList);
